import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { ADMIN_COMMERCIAL_FEATURES_QUERY_KEY } from '@/state/queries/admin/use-admin-commercial-features-query';

export type UpdateCommercialFeatureBody = {
  displayName?: string;
  description?: string;
  allowedScopeTypes?: string[];
  category?: string;
  deprecated?: boolean;
  replacedByKey?: string | null;
};

export function useUpdateCommercialFeatureMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }: { id: string; body: UpdateCommercialFeatureBody }) => {
      const token = await getToken();
      await sendJSONRequest({
        url: `${import.meta.env.VITE_API_URL}/commercial-features/${id}`,
        method: METHOD.PATCH,
        body,
        token: token ?? '',
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_COMMERCIAL_FEATURES_QUERY_KEY] });
    },
  });
}
